import request from '@/config/axios'

export const GetLang = (params) => {
  return request.get({
    url: '/ik-api/v1/i18n-data',
    params,
    timeout: 5000
  })
}

export const RegisterLang = (data) => {
  return request.post({
    url: '/ik-api/v1/i18n-data/builtin',
    data:data,
    timeout: 5000
  })
}

export const getAgentSettings = (params) => {
  return request.get({
    url: '/ik-api/v1/agentsettings',
    params: params
  })
}
export const importKb = (data) => {
  return request.post({
    url: '/ik-api/v1/faultknowledge/import',
    data: data
  })
}

export const addKb = (data) => {
  return request.post({
    url: '/ik-api/v1/faultknowledge',
    data: data
  })
}

export const deleteKb = (id) => {
  return request.delete({
    url: `/ik-api/v1/faultknowledge?id=${id}`
  })
}

export const editKb = (data) => {
  return request.put({
    url: '/ik-api/v1/faultknowledge',
    data: data
  })
}

export const getKbList = (params) => {
  return request.get({
    url: '/ik-api/v1/faultknowledge',
    params: params
  })
}

export const getKbListById = (id) => {
  return request.get({
    url: `/ik-api/v1/faultknowledge/byid?id=${id}`
  })
}

export const getKbFileInfoById = (id) => {
  return request.get({
    url: `/ik-api/v1/faultknowledge/fileinfo/byknowledgeid?id=${id}`
  })
}

export const addType = (data) => {
  return request.post({
    url: '/ik-api/v1/faultknowledge/faulttype',
    data: data
  })
}

export const deleteType = (id) => {
  return request.delete({
    url: `/ik-api/v1/faultknowledge/faulttype?id=${id}`
  })
}

export const editType = (data) => {
  return request.put({
    url: '/ik-api/v1/faultknowledge/faulttype',
    data: data
  })
}

export const getTypes = (params) => {
  return request.get({
    url: '/ik-api/v1/faultknowledge/faulttype',
    params: params
  })
}

export const addPosition = (data) => {
  return request.post({
    url: '/ik-api/v1/faultknowledge/position',
    data: data
  })
}

export const deletePosition = (id) => {
  return request.delete({
    url: `/ik-api/v1/faultknowledge/position?id=${id}`
  })
}

export const editPosition = (data) => {
  return request.put({
    url: '/ik-api/v1/faultknowledge/position',
    data: data
  })
}

export const getPositions = (params) => {
  return request.get({
    url: '/ik-api/v1/faultknowledge/position',
    params: params
  })
}

export const addDeviceType = (data) => {
  return request.post({
    url: '/ik-api/v1/faultknowledge/devicetype',
    data: data
  })
}

export const deleteDeviceType = (id) => {
  return request.delete({
    url: `/ik-api/v1/faultknowledge/devicetype?id=${id}`
  })
}

export const editDeviceType = (data) => {
  return request.put({
    url: '/ik-api/v1/faultknowledge/devicetype',
    data: data
  })
}

export const getDeviceTypeById = (id) => {
  return request.get({
    url: `/ik-api/v1/faultknowledge/devicetype/byid?id=${id}`,
  })
}

export const getDeviceTypeList = (params) => {
  return request.get({
    url: '/ik-api/v1/faultknowledge/devicetype',
    params: params
  })
}

export const getQueryConditions = (params) => {
  return request.get({
    url: '/ik-api/v1/faultknowledge/condition',
    params: params
  })
}

export const addDocCategory = (data) => {
  return request.post({
    url: '/ik-api/v1/docknowledge/category',
    data: data
  })
}

export const deleteDocCategory = (id) => {
  return request.delete({
    url: `/ik-api/v1/docknowledge/category?id=${id}`,
    timeout: 60000
  })
}

export const editDocCategory = (data) => {
  return request.put({
    url: '/ik-api/v1/docknowledge/category',
    data: data
  })
}

export const getDocCategories = (params) => {
  return request.get({
    url: '/ik-api/v1/docknowledge/category',
    params: params
  })
}

export const getDocCategoryById = (id) => {
  return request.get({
    url: `/ik-api/v1/docknowledge/category/byid?id=${id}`
  })
}

export const getDocIds = (params) => {
  return request.get({
    url: '/ik-api/v1/docknowledge/ids',
    params: params
  })
}

export const addDocType = (data) => {
  return request.post({
    url: '/ik-api/v1/docknowledge/type',
    data: data
  })
}

export const deleteDocType = (id) => {
  return request.delete({
    url: `/ik-api/v1/docknowledge/type?id=${id}`
  })
}

export const getDocTypes = (params) => {
  return request.get({
    url: '/ik-api/v1/docknowledge/type',
    params: params
  })
}

export const getDocTypeById = (id) => {
  return request.get({
    url: `/ik-api/v1/docknowledge/type/byid?id=${id}`
  })
}

export const addDocDomain = (data) => {
  return request.post({
    url: '/ik-api/v1/docknowledge/domain',
    data: data
  })
}

export const deleteDocDomain = (id) => {
  return request.delete({
    url: `/ik-api/v1/docknowledge/domain?id=${id}`
  })
}

export const getDocDomains = (params) => {
  return request.get({
    url: '/ik-api/v1/docknowledge/domain',
    params: params
  })
}

export const getDocDomainById = (id) => {
  return request.get({
    url: `/ik-api/v1/docknowledge/domain/byid?id=${id}`
  })
}

export const uploadDoc = (data) => {
  return request.post({
    url: '/ik-api/v1/docknowledge',
    data: data
  })
}

export const deleteDoc = (id) => {
  return request.delete({
    url: `/ik-api/v1/docknowledge?id=${id}`
  })
}

export const editDoc = (data) => {
  return request.put({
    url: '/ik-api/v1/docknowledge',
    data: data
  })
}

export const editDocSyncInfo = (data) => {
  return request.put({
    url: '/ik-api/v1/docknowledge/aisyncstatus',
    data: data
  })
}

export const getDocs = (params) => {
  return request.get({
    url: '/ik-api/v1/docknowledge',
    params: params
  })
}

export const getDocUrl = (id) => {
  return request.get({
    url: `/ik-api/v1/docknowledge/presignedurl?id=${id}`
  })
}

export const getDocSerchCondition = (params) => {
  return request.get({
    url: `/ik-api/v1/docknowledge/condition`,
    params: params
  })
}

export const getDocsById = (params) => {
  return request.get({
    url: '/ik-api/v1/docknowledge/byid',
    params: params
  })
}

export const getDocsByFileIds = (data) => {
  return request.post({
    url: '/ik-api/v1/docknowledge/byfileids',
    data: data
  })
}

export const addManualCategory = (data) => {
  return request.post({
    url: '/ik-api/v1/manual/category',
    data: data
  })
}

export const deleteManualCategory = (id) => {
  return request.delete({
    url: `/ik-api/v1/manual/category?id=${id}`
  })
}

export const editManualCategory = (data) => {
  return request.put({
    url: '/ik-api/v1/manual/category',
    data: data
  })
}

export const getManualCategoryList = (params) => {
  return request.get({
    url: '/ik-api/v1/manual/category',
    params: params
  })
}

export const getManualCategoryById = (params) => {
  return request.get({
    url: '/ik-api/v1/manual/category/byid',
    params: params
  })
}

export const addManualType = (data) => {
  return request.post({
    url: '/ik-api/v1/manual/type',
    data: data
  })
}

export const deleteManualType = (id) => {
  return request.delete({
    url: `/ik-api/v1/manual/type?id=${id}`
  })
}

export const getManualTypes = (params) => {
  return request.get({
    url: '/ik-api/v1/manual/type',
    params: params
  })
}

export const getManualTypeById = (id) => {
  return request.get({
    url: `/ik-api/v1/manual/type/byid?id=${id}`
  })
}

export const uploadManual = (data) => {
  return request.post({
    url: '/ik-api/v1/manual',
    data: data
  })
}

export const deleteManual = (id) => {
  return request.delete({
    url: `/ik-api/v1/manual?id=${id}`
  })
}

export const editManual = (data) => {
  return request.put({
    url: '/ik-api/v1/manual',
    data: data
  })
}

export const getManuals = (params) => {
  return request.get({
    url: '/ik-api/v1/manual',
    params: params
  })
}

export const getManualUrl = (id) => {
  return request.get({
    url: `/ik-api/v1/manual/presignedurl?id=${id}`
  })
}

export const getManualSerchCondition = (params) => {
  return request.get({
    url: `/ik-api/v1/manual/condition`,
    params: params
  })
}

export const editManualSyncInfo = (data) => {
  return request.put({
    url: '/ik-api/v1/manual/aisyncstatus',
    data: data
  })
}


export const getManualIds = (params) => {
  return request.get({
    url: '/ik-api/v1/manual/ids',
    params: params
  })
}

export const getManualById = (params) => {
  return request.get({
    url: '/ik-api/v1/manual/byid',
    params: params
  })
}

export const uploadEntry = (data) => {
  return request.post({
    url: '/ik-api/v1/entry',
    data: data
  })
}

export const deleteEntry = (id) => {
  return request.delete({
    url: `/ik-api/v1/entry?id=${id}`
  })
}

export const editEntry = (data) => {
  return request.put({
    url: '/ik-api/v1/entry',
    data: data
  })
}

export const editEntrySyncInfo = (data) => {
  return request.put({
    url: '/ik-api/v1/entry/aisyncstatus',
    data: data
  })
}

export const getEntries = (params) => {
  return request.get({
    url: '/ik-api/v1/entry',
    params: params
  })
}

export const getEntryUrl = (id) => {
  return request.get({
    url: `/ik-api/v1/entry/presignedurl?id=${id}`
  })
}

export const getEntrySerchCondition = (params) => {
  return request.get({
    url: `/ik-api/v1/entry/condition`,
    params: params
  })
}

export const getEntriesById = (params) => {
  return request.get({
    url: '/ik-api/v1/entry/byid',
    params: params
  })
}

export const getEntriesByFileIds = (data) => {
  return request.post({
    url: '/ik-api/v1/entry/byfileids',
    data: data
  })
}

export const getEntryIds = (params) => {
  return request.get({
    url: '/ik-api/v1/entry/ids',
    params: params
  })
}

export const addEntryType = (data) => {
  return request.post({
    url: '/ik-api/v1/entry/type',
    data: data
  })
}

export const deleteEntryType = (id) => {
  return request.delete({
    url: `/ik-api/v1/entry/type?id=${id}`
  })
}

export const getEntryTypes = (params) => {
  return request.get({
    url: '/ik-api/v1/entry/type',
    params: params
  })
}

export const getEntryTypeById = (id) => {
  return request.get({
    url: `/ik-api/v1/entry/type/byid?id=${id}`
  })
}
